<template>
  <AAlert
    variant="danger"
    body-class="unknown-block">
    <p class="error">
      Unknown block "{{ blockName }}" for content type "{{ props.content?.contentType }}"
    </p>
  </AAlert>
</template>

<script lang="ts" setup>
import type { ElementItem } from "../../types";
import { useUmbracoLoggedInState, showError, createError, useNuxtApp, getBlockComponentName, computed } from "#imports";

const props = defineProps<{
  content: ElementItem;
  settings: ElementItem;
}>();

const blockName = computed( () => {
  let result = null;

  if ( props.content ) {
    result = getBlockComponentName( props.content?.contentType );
  }

  return result;
} );

const isLocal = () => {
  if ( import.meta.server ) {
    const nuxtApp = useNuxtApp();
    return nuxtApp.ssrContext?.event.node.req.headers.host?.startsWith( "localhost" ) ?? false;
  } else {
    return window.location.hostname === "localhost";
  }
};

const showDebugInfo = useUmbracoLoggedInState().value || isLocal();

if ( !showDebugInfo ) {
  const err = {
    statusCode: 500,
    statusMessage: `Unable to find block component with name '${props.content?.contentType}'`,
    fatal: true,
  };

  showError( err ); // todo: remove when https://github.com/nuxt/nuxt/issues/15432 is fixed

  if ( import.meta.server ) {
    throw createError( err );
  }
}
</script>

<style lang="scss" scoped>

</style>
